
import * as React from 'react'
import { Text, View, ScrollView, TouchableOpacity, ActivityIndicator } from 'react-native'
import { MaterialCommunityIcons, Ionicons } from '@expo/vector-icons'
import { useTheme } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import Axios from 'axios'

export default function ModalFilter({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [list_route, setListRoute] = React.useState()
    const [list_product, setListProduct] = React.useState()
    const [list_direction, setListDirection] = React.useState()

    React.useEffect(() => {
        const { routes, products, directions } = route?.params?.filters
        console.log(route?.params?.filters)
        Promise.all([Axios.get('/api/list_route'), Axios.get('/api/list_product'), Axios.get('/api/list_direction')])
            .then((results) => {
                console.log(results)
                try {
                    if (routes && routes.length > 0)
                        results[0].data.data.map((item) => {
                            if (routes.find(element => element === item.id)) {
                                item.not_check = false
                            } else item.not_check = true
                        })
                    if (products && products.length > 0)
                        results[1].data.data.map((item) => {
                            if (products.find(element => element === item.id)) {
                                item.not_check = false
                            } else item.not_check = true
                        })
                    if (directions && directions.length > 0)
                        results[2].data.data.map((item) => {
                            if (directions.find(element => element === item.id)) {
                                item.not_check = false
                            } else item.not_check = true
                        })
                } catch (error) {
                }
                setListRoute(results[0].data.data)
                setListProduct(results[1].data.data)
                setListDirection(results[2].data.data)
            }).catch(err => console.log(err))
    }, [])

    const acceptFilter = () => {
        let routes = [], products = [], directions = []
        list_route.map(item => {
            if (!item.not_check) routes.push(item.id)
        })
        list_product.map(item => {
            if (!item.not_check) products.push(item.id)
        })
        list_direction.map(item => {
            if (!item.not_check) directions.push(item.id)
        })
        navigation.navigate('Home', { screen: 'process', params: { filters: { routes, products, directions } } })
    }

    return (
        <View style={{ flex: 1, backgroundColor: 'white' }}>
            <View style={{ paddingTop: insets.top ? insets.top : 0, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <TouchableOpacity onPress={() => navigation.goBack()}>
                    <Ionicons name="ios-close" size={32} color={colors.text} style={{ paddingHorizontal: 24, paddingVertical: 8 }} />
                </TouchableOpacity>
                <Text style={{ flex: 1, textAlign: 'center', color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 16 }}>BỘ LỌC</Text>
                <TouchableOpacity>
                    <Ionicons name="ios-close" size={32} color={colors.text} style={{ paddingHorizontal: 24, paddingVertical: 8, opacity: 0 }} />
                </TouchableOpacity>
            </View>
            {
                list_route && list_product && list_direction ? <>
                    <ScrollView>
                        <View style={{ paddingHorizontal: 12, marginTop: 12 }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 18, color: colors.text }}>Tuyến đường</Text>
                            {
                                list_route && list_route.map((item, idx) => {
                                    return <TouchableOpacity key={idx} style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 3 }}
                                        onPress={() => {
                                            let list = JSON.parse(JSON.stringify(list_route))
                                            list[idx].not_check = !list[idx].not_check
                                            setListRoute(list)
                                        }}>
                                        {
                                            item.not_check ? <MaterialCommunityIcons name="checkbox-blank" size={22} color={'lightgray'} /> :
                                                <MaterialCommunityIcons name="checkbox-marked" size={22} color={colors.primary} />
                                        }
                                        <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 16, color: colors.text, marginLeft: 8 }}>{item.name}</Text>
                                    </TouchableOpacity>
                                })
                            }
                        </View>
                        <View style={{ paddingHorizontal: 12, marginTop: 12 }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 18, color: colors.text }}>Sản phẩm</Text>
                            {
                                list_product && list_product.map((item, idx) => {
                                    return <TouchableOpacity key={idx} style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 3 }}
                                        onPress={() => {
                                            let list = JSON.parse(JSON.stringify(list_product))
                                            list[idx].not_check = !list[idx].not_check
                                            setListProduct(list)
                                        }}>
                                        {
                                            item.not_check ? <MaterialCommunityIcons name="checkbox-blank" size={22} color={'lightgray'} /> :
                                                <MaterialCommunityIcons name="checkbox-marked" size={22} color={colors.primary} />
                                        }
                                        <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 16, color: colors.text, marginLeft: 8 }}>{item.name}</Text>
                                    </TouchableOpacity>
                                })
                            }
                        </View>
                        <View style={{ paddingHorizontal: 12, marginTop: 12 }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 18, color: colors.text }}>Chiều</Text>
                            {
                                list_direction && list_direction.map((item, idx) => {
                                    return <TouchableOpacity key={idx} style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 3 }}
                                        onPress={() => {
                                            let list = JSON.parse(JSON.stringify(list_direction))
                                            list[idx].not_check = !list[idx].not_check
                                            setListDirection(list)
                                        }}>
                                        {
                                            item.not_check ? <MaterialCommunityIcons name="checkbox-blank" size={22} color={'lightgray'} /> :
                                                <MaterialCommunityIcons name="checkbox-marked" size={22} color={colors.primary} />
                                        }
                                        <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 16, color: colors.text, marginLeft: 8 }}>{item.name}</Text>
                                    </TouchableOpacity>
                                })
                            }
                        </View>
                    </ScrollView>
                    <TouchableOpacity style={{
                        width: 300, backgroundColor: colors.text, borderRadius: 10, marginTop: 12, marginBottom: 12 + insets.bottom,
                        height: 48, justifyContent: 'center', alignItems: 'center', alignSelf: 'center'
                    }} onPress={acceptFilter}>
                        <Text style={{ fontSize: 18, color: 'white', fontFamily: 'Nunito_900Black', alignSelf: 'center' }}>
                            XÁC NHẬN
                </Text>
                    </TouchableOpacity>
                </> : <View style={{ marginTop: 12, justifyContent: 'center', alignItems: 'center' }}>
                        <ActivityIndicator size="small" color={colors.text} />
                    </View>
            }
        </View>
    );
}